import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import Button from "@mui/material/Button";

export const personelPermissionColumns = (
  handleApproveOrReject,
  handleDocument,
  isApproveLoading,
  handleSystemForm
) => [
  {
    field: "name",
    headerName: "Ad",
    sortable: false,
    filterable: false,
    minWidth: 120,
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "surname",
    headerName: "Soyad",
    sortable: false,
    filterable: false,
    minWidth: 120,
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "dayoffTypeName",
    headerName: "İzin Türü",
    sortable: false,
    filterable: false,
    minWidth: 140,
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "departmentName",
    headerName: "Departman",
    sortable: false,
    filterable: false,
    minWidth: 140,
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "start_Date",
    headerName: "İzin Başlangıç Tarihi",
    sortable: false,
    filterable: false,
    minWidth: 150,
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row) =>
      row && moment(row.start_Date).format("DD/MM/YYYY"),
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "end_Date",
    headerName: "İzin Bitiş Tarihi",
    sortable: false,
    filterable: false,
    minWidth: 150,
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row) =>
      row && moment(row.end_Date).format("DD/MM/YYYY"),
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "isApprove",
    headerName: "Onay Durumu",
    minWidth: 120,
    flex: 1,
    sortable: false,
    filterable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.row.isApprove === null ? (
          <HourglassBottomIcon color="info" />
        ) : params.row.isApprove ? (
          <CheckCircleIcon color="success" />
        ) : (
          <CancelIcon color="error" />
        )}
      </div>
    ),
  },
  {
    field: "isHalfDay",
    headerName: "Yarım/Tam Gün",
    minWidth: 120,
    flex: 1,
    sortable: false,
    filterable: false,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row) =>
      row && row.isHalfDay ? "Yarım Gün" : "Tam Gün",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "İşlemler",
    flex: 1,
    minWidth: 150,
    sortable: false,
    filterable: false,
    disableExport: true,
    renderCell: (params) => (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          marginTop: 10,
          marginBottom: 10,
          justifyContent: "center",
          alignItems: "flex-start",
          width: "100%",
          minHeight: 60, // daha küçük yükseklik
          overflow: "visible",
          flexDirection: "column",
        }}
      >
        <Button
          variant="contained"
          color="success"
          size="small"
          disabled={params.row.isApprove === true}
          loading={isApproveLoading}
          sx={{
            minWidth: { xs: 80, sm: 100 },
            fontSize: { xs: "0.75rem", sm: "0.9rem" },
            height: 28, // buton yüksekliği küçültüldü
            py: 0,
          }}
          onClick={() =>
            handleApproveOrReject({ id: params.row.id, isApprove: true })
          }
        >
          Onayla
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          loading={isApproveLoading}
          disabled={params.row.isApprove === false}
          sx={{
            minWidth: { xs: 80, sm: 100 },
            fontSize: { xs: "0.75rem", sm: "0.9rem" },
            height: 28,
            py: 0,
          }}
          onClick={() =>
            handleApproveOrReject({ id: params.row.id, isApprove: false })
          }
        >
          Reddet
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          loading={isApproveLoading}
          sx={{
            minWidth: { xs: 80, sm: 100 },
            fontSize: { xs: "0.75rem", sm: "0.9rem" },
            height: 28,
            py: 0,
          }}
          onClick={() => handleDocument(params.row.id)}
        >
          Belgeler
        </Button>
        <Button
          variant="contained"
          color="warning"
          size="small"
          sx={{
            minWidth: { xs: 80, sm: 100 },
            fontSize: { xs: "0.75rem", sm: "0.9rem" },
            height: 28,
            py: 0,
          }}
          onClick={() => handleSystemForm(params.row.id)}
        >
          Sistem Formu
        </Button>
        {/* <Button
          variant="contained"
          color="warning"
          size="small"
          loading={isApproveLoading}
          sx={{
            minWidth: { xs: 80, sm: 100 },
            fontSize: { xs: "0.75rem", sm: "0.9rem" },
            height: 28,
            py: 0,
          }}
          // onClick={() => handleDocument(params.row.id)}
        >
          Sistem Formu
        </Button> */}
      </div>
    ),
  },
];
